import React from "react";
import styled from "@emotion/styled";
import {NavLink, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {getTabs} from "modules/selectors";
import {buildHelpPathName} from "modules/utils";

const Wrapper = styled.div`
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	display: flex;
	justify-content: center;
	text-align: center;

	a {
		display: block;
		height: 48px;
		width: 100%;
		line-height: 48px;
		padding: 0 2px;
		font-size: 16px;
		font-weight: 500;
		font-family: "Hind", sans-serif;
		color: #848484;
		border-bottom: 2px solid #cccccc;
		white-space: nowrap;
	}

	a.active,
	a:hover {
		color: ${({theme}) => theme.colorPalette.secondary};
		border-bottom: 2px solid ${({theme}) => theme.colorPalette.secondary};
	}

	@media (min-width: 769px) {
		a {
			padding: 0 16px;
		}
	}
`;

export const Navigation: React.FC = () => {
	const tabs = useSelector(getTabs);
	const {search} = useLocation();

	return (
		<Wrapper>
			{tabs.map((tab) => (
				<NavLink key={tab.id} to={`${buildHelpPathName(tab.name)}${search}`}>
					{tab.name}
				</NavLink>
			))}
		</Wrapper>
	);
};
